import { combineReducers } from '@reduxjs/toolkit';
import modalReducer from './modal-slice';
import { reducer as timesheetStatus } from './timesheet-status-slice';

const rootReducer = combineReducers({
  modal: modalReducer,
  timesheetStatus,
});

export default rootReducer;
